/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {SPORTS_BANNER} from "../../assets/images"

export const Banner = {
 collectibles:   {
        image: "https://i.ibb.co/fkdWqJJ/collectibles-1.jpg",
        title: "Collectibles",
        body: `Unlock $1 Billion market of Traditional “Physical” rare collectibles including coins and whiskey as NFTs. Address Human Desire and Natural Tendency to collect things that are eye-catching and rare.`,
        footer: `Enable leading brands to expand reach to Gen-Z by issuing collectibles.`,
        blurBox: true,
        align: 'left'
    },
sports:{
    image: SPORTS_BANNER,
    title: "Sports",
    body: `Curate and Monetize Journey of Achievements as Digital Collectibles including Individual World Records, Team/Franchise Wins. Create continued anticipation and build sustainable revenue stream.`,
    footer: `Engage and Incentivize fans using Digital Collectibles as Tokens and engage by Gamification.`,
    blurBox: true,
    align: 'left'
},
entertainment:{
    image: "https://i.ibb.co/cXmjtCd/entertainment.jpg",
    title: "Entertainment",
    body: `Curate and Monetize Achievements, Unique Moments, Creations and Back Stage Moments as Digital Collectibles and NFTs.`,
    footer: `Enable Production houses and Brands to cross sell services to NFT owners.`,
    blurBox: true,
    align: 'left'
}
}


    